module.exports = __webpack_public_path__ + "img/reset-key-fill.aeea7d8e.svg";